<template>
  <el-button :size="size" :type="type" :plain="plain" :text="i18nConfig(text)" :bg="bg" :link="link" :round="round"
    :circle="circle" :loading="loading" :disabled="disabled" :loadingIcon="loadingIcon" :autofocus="autofocus"
    :nativeType="nativeType" :autoInsertSpace="autoInsertSpace" :color="color" :dark="dark" :tag="tag">
    <template #loading>
      <slot name="loading"></slot>
    </template>
    <template #icon v-if="$slots.icon">
      <slot name="icon"></slot>
    </template>
    <slot v-if="!soltText"></slot>
    <template v-else>
      {{ i18nConfig(soltText) }}
    </template>
  </el-button>
</template>

<script>
import { i18nConfig } from '@/utils/ruoyi'
import { reactive, toRefs, getCurrentInstance, onMounted, nextTick } from 'vue'
export default {
  name: "gljy-button",
  emits: ["change", "update:value"],
  props: {
    size: String,
    type: String,
    plain: Boolean,
    text: Boolean,
    bg: Boolean,
    link: Boolean,
    round: Boolean,
    circle: Boolean,
    loading: Boolean,
    disabled: Boolean,
    loadingIcon: String,
    autofocus: Boolean,
    nativeType: String,
    autoInsertSpace: Boolean,
    color: String,
    dark: Boolean,
    tag: String,
  },
  setup(props, context) {
    const { proxy } = getCurrentInstance();
    const datas = reactive({
      i18nConfig: i18nConfig,
      soltText: undefined,
    })

    const methods = {
    }

    onMounted(() => {
      nextTick(() => {
        try {
          const slotDefault = proxy.$slots?.default();
          if (slotDefault.length == 1 && typeof slotDefault[0].type == "symbol") {
            datas.soltText = slotDefault[0].children?.trim();
          }
        } catch (e) {
        }
      })
    })


    return {
      ...toRefs(datas),
      ...methods
    }
  }
}
</script>

<style lang="scss" scoped></style>